import React from "react";
import "./Error.scss";
import { Link } from "react-router-dom";

const Error = () => {
  return (
    <div className="error">
      <div className="error_wrap">
        <div className="error_text">
          <div className="error_bn">
            <img src={require("../../img/404.jpeg")} />
          </div>
          <span >
            Opps! Page <br />
            Not Found
          </span>
          <p>
            You must have picked the wrong door because I haven't been able to
            <br /> lay my eye onthe page you've been searching for.
          </p>
          <Link to="/">
            <button>Back to Home</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Error;
